import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { MainComponent } from '../../common/pages/main/main.component';
import { Company } from '../../services/company/company.model';
import { SettingService } from '../../common/services/setting/setting.service';
import { CompanyService } from '../../services/company/company.service';
import { SelectService } from '../../common/services/select/select.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-company-tab',
  templateUrl: './company-tab.component.html',
  styleUrls: ['./company-tab.component.scss']
})
export class CompanyTabComponent  extends MainComponent {

  public item: Company;
  
  @Input()
  model: string;

  @Input()
  modelKey: string;

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: CompanyService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public backURL: BackurlService,
    public dialog: MatDialog,
  ) {
    super(_cd, setting, db, select, route, router, backURL, dialog);
    this.item = new Company(null, setting);
  }

  goItem() {
    if (this.model && this.modelKey && this.item.values.$key) {
      this.backURL.addURL(`/${this.model}/${this.modelKey}`);
      this.router.navigate([`/companies/${this.item.values.$key}`]);
    }
  }
}
